import Vue from "vue"
import Hammer from "hammerjs"

Vue.directive("swipe", {
  bind(el, binding) {
    el.mc = new Hammer(el)
    el.mc.on("swipe", (e) => binding.value(e))
  },
  unbind(el) {
    el.mc.destroy()
  }
})

Vue.directive("swipe-left", {
  bind: function (el, binding) {
    el.mc = new Hammer(el)
    el.mc.on("swipeleft", (e) => binding.value(e))
  },
  unbind(el) {
    el.mc.destroy()
  }
})

Vue.directive("swipe-right", {
  bind: function (el, binding) {
    el.mc = new Hammer(el)
    el.mc.on("swiperight", (e) => binding.value(e))
  },
  unbind(el) {
    el.mc.destroy()
  }
})
